import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e99d86a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_main_wrap" }
const _hoisted_2 = { class: "message_header" }
const _hoisted_3 = { class: "message_avatar_wrap" }
const _hoisted_4 = ["onContextmenu"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "comment_action_group_item",
  "data-key": 4
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "comment_action_group_item",
  "data-key": 5
}, "拉黑", -1))
const _hoisted_8 = { class: "message_avatar_wrapr" }
const _hoisted_9 = ["onContextmenu"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "comment_action_group_item",
  "data-key": 4
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "comment_action_group_item",
  "data-key": 5
}, "拉黑", -1))
const _hoisted_13 = { class: "user_name" }
const _hoisted_14 = { class: "time" }
const _hoisted_15 = { class: "message_content_wrap" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message_avatar" }, null, -1))
const _hoisted_17 = { class: "message_content" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "message_child_box"
}
const _hoisted_20 = { class: "message_avatar" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "message_content" }
const _hoisted_23 = { class: "user_name" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "message_avatar" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "message_content" }
const _hoisted_30 = { class: "user_name" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 1,
  class: "message_child_btn"
}

import { onMounted, onUnmounted, ref, reactive, createVNode } from 'vue';
import { Spin } from 'ant-design-vue';
import { LoadingOutlined, SwapOutlined } from '@ant-design/icons-vue';
import { ChatRecord, formatEmoji, GroupChat } from '@/pinia/types/console';
import { useConsoleStore } from '@/pinia/console';
import http from '@/api';

interface Props {
  sourceData: GroupChat;
  self: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupMsgItemChat',
  props: {
    sourceData: null,
    self: { type: Boolean }
  },
  emits: ['click:setEditPUser'],
  setup(__props: any, { emit }) {

const props = __props as {
  sourceData: GroupChat;
  self: boolean;
};

const aSpin = Spin;

const consoleStore = useConsoleStore();

const data = reactive(props.sourceData);



const indicator = createVNode(LoadingOutlined, {
  style: {
    fontSize: '18px',
  },
  spin: true,
});
const loading = ref(false);
const isShow = ref(false);
const list = ref<ChatRecord[]>([]);
const pageConfig = reactive({
  current: 0,
  page_num: 10,
  total: 0,
});
const updateList = () => {
  if (list.value.length !== 0 && !isShow.value) {
    isShow.value = true;
    return;
  }
  let commentIdArr: string[] = [];
  if (data.chat_record) {
    commentIdArr = data.chat_record
      .map((obj) => {
        return obj.msg_id;
      })
      .join(',')
      .split(',');
  }
  loading.value = true;
  http.liveChat
    .getMorePrivate({
      params: {
        chat_list_id: data.chat_list_id,
        studio_id: consoleStore.consoleInfo.id,
        page: pageConfig.current + 1,
        page_num: pageConfig.page_num,
      },
    })
    .then((res) => {
      const resData = res.data.data;
      pageConfig.current = resData.current_page;
      pageConfig.total = resData.total;
      const arr: ChatRecord[] = [];
      resData.data.forEach((e: ChatRecord) => {
        if (commentIdArr.includes(e.msg_id)) {
          return false;
        }
        e.content = formatEmoji(e.content);
        arr.push(e);
      });
      list.value = list.value.concat(arr);
    })
    .finally(() => {
      loading.value = false;
      isShow.value = true;
    });
};
const onPack = () => {
  list.value = [];
  pageConfig.current = 0;
  pageConfig.total = 0;
  isShow.value = false;
};

const msgItemLRef = ref();
const msgItemRRef = ref();
const msgLVisibel = ref(false);
const msgRVisibel = ref(false);
const msgSetLRef = ref();
const msgSetRRef = ref();
const onShowBut = (e: MouseEvent) => {
  e.preventDefault();
  if (e.button === 2) {
    if (msgItemLRef.value.contains(e.target)) {
      consoleStore.chatMarkVisible = true;
      msgLVisibel.value = true;
    } else if (msgItemRRef.value.contains(e.target)) {
      consoleStore.chatMarkVisible = true;
      msgRVisibel.value = true;
    } else {
      msgLVisibel.value = false;
      msgRVisibel.value = false;
    }
  }
};

const onClickMsgEdit = (event: Event, type: string) => {
  const keyIndex = parseInt((event.target as HTMLInputElement).dataset.key as string);
  const formData = {
    key: keyIndex,
    data: data,
    type: type,
  };
  emit('click:setEditPUser', formData);
  msgLVisibel.value = false;
  msgRVisibel.value = false;
  consoleStore.chatMarkVisible = false;
};

const onblurBut = (e: MouseEvent) => {
  if (!msgSetLRef.value.contains(e.target)) {
    msgLVisibel.value = false;
    consoleStore.chatMarkVisible = false;
  }
  if (!msgSetRRef.value.contains(e.target)) {
    msgRVisibel.value = false;
    consoleStore.chatMarkVisible = false;
  }
};
onMounted(() => {
  window.addEventListener('click', onblurBut);
});
onUnmounted(() => {
  window.removeEventListener('click', onblurBut);
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["message_main", { checked: msgLVisibel.value || msgRVisibel.value }]),
      onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "message_avatar",
            ref_key: "msgItemLRef",
            ref: msgItemLRef,
            onContextmenu: _withModifiers(onShowBut, ["prevent","stop"])
          }, [
            _createElementVNode("img", {
              src: data.avatar_url,
              alt: ""
            }, null, 8, _hoisted_5)
          ], 40, _hoisted_4),
          (data.chat_list_id)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "msgSetLRef",
                ref: msgSetLRef,
                class: "comment_action_group comment_left",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMsgEdit($event, 'uid')))
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(data.to_status === 2 ? '解禁' : '禁言'), 1),
                _hoisted_7
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(SwapOutlined), { class: "swap_out_lined" }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "message_avatar",
            ref_key: "msgItemRRef",
            ref: msgItemRRef,
            onContextmenu: _withModifiers(onShowBut, ["prevent","stop"])
          }, [
            _createElementVNode("img", {
              src: data.to_avatar_url,
              alt: ""
            }, null, 8, _hoisted_10)
          ], 40, _hoisted_9),
          (data.chat_list_id)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "msgSetRRef",
                ref: msgSetRRef,
                class: "comment_action_group comment_right",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickMsgEdit($event, 'to_uid')))
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(data.status === 2 ? '解禁' : '禁言'), 1),
                _hoisted_12
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(data.created_at), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            innerHTML: data.content,
            class: "message_txt"
          }, null, 8, _hoisted_18),
          (data.chat_record)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.chat_record, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.msg_id,
                    class: "message_main"
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: item.avatar_url,
                        alt: ""
                      }, null, 8, _hoisted_21)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(item.nickname), 1)
                      ]),
                      _createElementVNode("div", {
                        innerHTML: item.content,
                        class: "message_txt"
                      }, null, 8, _hoisted_25)
                    ])
                  ]))
                }), 128)),
                (isShow.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (msgItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: msgItem.msg_id,
                          class: "message_main"
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("img", {
                              src: msgItem.avatar_url,
                              alt: ""
                            }, null, 8, _hoisted_28)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(msgItem.nickname), 1)
                            ]),
                            _createElementVNode("div", {
                              innerHTML: msgItem.content,
                              class: "message_txt"
                            }, null, 8, _hoisted_32)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _withDirectives(_createVNode(_unref(aSpin), { indicator: _unref(indicator) }, null, 8, ["indicator"]), [
                    [_vShow, loading.value]
                  ])
                ]),
                (!loading.value && data.chat_record.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (pageConfig.total !== data.chat_record.length + list.value.length || !isShow.value)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: updateList
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("查看更多评论>>")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            class: "message_child_a",
                            type: "link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("没有更多评论了")
                            ]),
                            _: 1
                          })),
                      (pageConfig.total > 0 && isShow.value)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 2,
                            type: "link",
                            class: "message_child_btn_unflod",
                            onClick: onPack
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("收起")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 34)
  ]))
}
}

})